import React from "react";
import { X } from "lucide-react";

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, isLoading, campaignName }) => {
  if (!isOpen) return null;

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center bg-black bg-opacity-50 transition-opacity">
      <div className="mx-4 w-full max-w-md bg-white rounded-2xl shadow-2xl">
        <div className="flex justify-between items-center px-6 py-4">
          <h3 className="font-sans text-xl font-bold text-gray-900">Delete Product Update</h3>
          <button onClick={onClose} className="text-gray-400 transition-colors hover:text-gray-600">
            <X className="w-6 h-6" />
          </button>
        </div>
        <div className="px-6 pb-6">
          <p className="text-sm text-gray-600">
            Delete <span className="font-semibold">{campaignName}</span>? This can't be undone from
            here - its send report will still be kept, but the campaign itself will be gone.
          </p>
        </div>
        <div className="flex gap-3 justify-end px-6 pb-6">
          <button
            onClick={onClose}
            className="px-5 py-2.5 text-sm font-bold text-gray-700 bg-white rounded-xl border-2 border-gray-200 hover:bg-gray-50 active:scale-95"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="px-5 py-2.5 text-sm font-bold text-white bg-red-600 rounded-xl disabled:opacity-50 hover:bg-red-700 active:scale-95"
          >
            {isLoading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
